export const FETCH_ROLES = 'role/FETCH_ROLES'
export const FETCH_ROLES_SUCCESS = 'role/FETCH_ROLES_SUCCESS'
export const FETCH_ROLES_FAILURE = 'role/FETCH_ROLES_FAILURE'
export const RESET_ROLES = 'role/RESET_ROLES'


// WEBPACK FOOTER //
// ./src/store/role/actionTypes.js